export default {"src":"/_next/static/media/Spinal Cord Tumors.2b26a9ab.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};